'use client'
import {
  SELLER_QUERY
} from "./chunk-AHEYDCQX.mjs";
import {
  SEO_QUERY
} from "./chunk-J54FE6N4.mjs";
import {
  ORGANIZER_QUERY
} from "./chunk-AWPL6XVN.mjs";
import {
  LOCATION_QUERY
} from "./chunk-KJDK3CSR.mjs";
import {
  RICHTEXT_QUERY
} from "./chunk-24EW7UVZ.mjs";
import {
  SCHEDULE_QUERY
} from "./chunk-HLVUCALY.mjs";
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";
import {
  CURRENCY_QUERY
} from "./chunk-PXTWVUHC.mjs";
import {
  gqlClient
} from "./chunk-6XSQRWIQ.mjs";
import {
  minifyGqlQuery
} from "./chunk-UBYW5IHO.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/events/detail.ts
import { gql } from "graphql-request";
import { useQuery } from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
var QUERY = gql`
query getEventDetail($lang: String, $limit: Int, $skip: Int, $where: EventFilter, $order: [EventOrder]) {
  eventCollection(locale: $lang, limit: $limit, skip: $skip, where: $where, order: $order) {
    total
    items {
      id
      title
      subtitle
      description{${RICHTEXT_QUERY}}
      slug
      image11{${IMAGE_QUERY}}
      image31{${IMAGE_QUERY}}
      price
      currency{${CURRENCY_QUERY}}
      priceUnit
      schedule{${SCHEDULE_QUERY}}
      button{
        label
        href
        theme
        shape
      }
      carousalCollection(limit: 40) {
        items {${IMAGE_QUERY}}
      }
      location{${LOCATION_QUERY}}
      category{id title slug}
      tagsCollection{
        items{id title slug}
      }
      sellersCollection(limit: 3){
        items{${SELLER_QUERY}}
      }
      ageRange{id slug title minimum maximum}
      organizer{${ORGANIZER_QUERY}}
      seo{${SEO_QUERY}}
      visibility
    }
  }
}
`;
var getEventDetail = (props) => __async(void 0, null, function* () {
  var _a;
  try {
    const res = yield gqlClient.request(minifyGqlQuery(QUERY), props);
    return ((_a = res.eventCollection.items) == null ? void 0 : _a[0]) || null;
  } catch (error) {
    throw new Exception({ error, name: "getEventDetailException" });
  }
});
var useGetEventDetail = (props, options) => {
  return useQuery(__spreadProps(__spreadValues({}, options), {
    queryKey: ["getEventDetail", props],
    queryFn: () => getEventDetail(props)
  }));
};

export {
  getEventDetail,
  useGetEventDetail
};
//# sourceMappingURL=chunk-I7H5BJVC.mjs.map